/**
 * Нижняя панель разделов — четыре экрана верхнего уровня (§2 спецификации):
 * «Велик» (главный, ввод номера), «Список», «Карта», «Задания».
 * `/bike/:id` и `/scan` открываются ПОВЕРХ этих экранов и своей вкладки не
 * имеют — так же, как раньше `/task/:id`/`/vehicle/:id`.
 *
 * Размеры продиктованы полем, а не вкусом: цель нажатия 56px по высоте,
 * подпись под иконкой — в перчатках и на солнце пиктограмма без слова
 * угадывается плохо.
 */
import { NavLink } from 'react-router-dom'

type Tab = { to: string; label: string; icon: string }

const TABS: Tab[] = [
  { to: '/', label: 'Велик', icon: '№' },
  { to: '/list', label: 'Список', icon: '≡' },
  { to: '/map', label: 'Карта', icon: '◎' },
  { to: '/tasks', label: 'Задания', icon: '☑' },
]

export function TabBar() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-20 flex border-t border-white/10
        bg-[#16181d]/95 backdrop-blur"
      // Жестовая полоса Android/iOS: без этого нижняя вкладка уезжает под неё.
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          // `end` только для корня: иначе он подсвечивался бы на всех путях.
          end={t.to === '/'}
          className={({ isActive }) =>
            `flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 text-xs
             ${isActive ? 'text-emerald-400' : 'text-white/60'}`
          }
        >
          <span aria-hidden className="text-lg leading-none">
            {t.icon}
          </span>
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
